/**
 * collection-sort-unavailable.js
 *
 * Hides product cards that fall outside the customer's selected delivery date window.
 * Previously sorted them to the end — now hides them entirely.
 *
 * A product is hidden if ANY of:
 *   1. data-available="false"  — Shopify inventory sold out
 *   2. data-available-to is set and effectiveDate > availableTo  — window has ended
 *   3. data-available-from is set and effectiveDate < availableFrom — window hasn't started
 *
 * Dependencies (loaded before this script in theme.liquid):
 *   - date-normalize.js  → window.DateNormalize
 *   - date-manager.js    → window.DateManager
 */

(function () {
  'use strict';

  function getEffectiveDate() {
    // Only use an explicitly selected date — never fall back to today.
    // Filtering against today on page load would hide all products if their
    // availablefrom dates are in the future (which they always are for delivery windows).
    if (window.kennicott_selected_date) return window.kennicott_selected_date;

    try {
      const stored = sessionStorage.getItem('kennicott_selected_date') ||
                     sessionStorage.getItem('komet_date_selected_iso');
      if (stored) return stored;
    } catch (_) {}

    // Check the date slider's selected chip
    const selectedChip = document.querySelector('.komet-ds__chip[aria-selected="true"]');
    if (selectedChip && selectedChip.dataset.iso) return selectedChip.dataset.iso;

    // No date selected yet — return null so we skip filtering
    return null;
  }

  function normalizeDate(raw) {
    if (!raw) return null;
    if (window.DateNormalize && window.DateNormalize.toISO) {
      return window.DateNormalize.toISO(raw);
    }
    const iso = String(raw).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`;
    const us = String(raw).match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (us) return `${us[3]}-${us[1].padStart(2,'0')}-${us[2].padStart(2,'0')}`;
    return null;
  }

  function isUnavailable(card, effectiveDate) {
    if (card.dataset.available === 'false') return true;

    const from = normalizeDate(card.dataset.availableFrom);
    const to   = normalizeDate(card.dataset.availableTo);

    // No date window set at all — product is always available
    if (!from && !to) return false;

    if (from && effectiveDate < from) return true;
    if (to   && effectiveDate > to)   return true;

    return false;
  }

  var EMPTY_MSG_ID = 'date-filter-empty-message';

  // Inject styles once
  (function injectStyles() {
    if (document.getElementById('date-filter-empty-styles')) return;
    var style = document.createElement('style');
    style.id = 'date-filter-empty-styles';
    style.textContent = [
      '.date-filter-empty {',
      '  padding: 48px 16px;',
      '  text-align: center;',
      '}',
      '.date-filter-empty__text {',
      '  font-size: 1.6rem;',
      '  color: #666;',
      '  margin: 0;',
      '}',
      '.date-filter-empty__date {',
      '  font-weight: 600;',
      '  color: #333;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  })();

  function getFormattedDate(isoDate) {
    // Parse YYYY-MM-DD without timezone conversion
    var m = String(isoDate).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return isoDate;
    var d = new Date(parseInt(m[1]), parseInt(m[2]) - 1, parseInt(m[3]));
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  }

  function showEmptyMessage(container, effectiveDate) {
    var existing = document.getElementById(EMPTY_MSG_ID);
    if (existing) {
      existing.querySelector('.date-filter-empty__date').textContent = getFormattedDate(effectiveDate);
      existing.style.display = '';
      return;
    }
    var msg = document.createElement('div');
    msg.id = EMPTY_MSG_ID;
    msg.className = 'date-filter-empty page-width';
    msg.innerHTML =
      '<p class="date-filter-empty__text">' +
        'No items available for <span class="date-filter-empty__date">' + getFormattedDate(effectiveDate) + '</span>.' +
        ' Try selecting a different delivery date.' +
      '</p>';
    container.insertAdjacentElement('afterend', msg);
  }

  function hideEmptyMessage() {
    var existing = document.getElementById(EMPTY_MSG_ID);
    if (existing) existing.style.display = 'none';
  }

  function sortGrid() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const effectiveDate = getEffectiveDate();
    const items = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
    if (items.length === 0) return;
    if (!effectiveDate) return;

    var visibleCount = 0;

    items.forEach(function (li) {
      const card = li.querySelector('.card-wrapper');
      if (!card) { visibleCount++; return; } // promo blocks always visible

      if (isUnavailable(card, effectiveDate)) {
        li.style.display = 'none';
        li.setAttribute('aria-hidden', 'true');
      } else {
        li.style.display = '';
        li.removeAttribute('aria-hidden');
        visibleCount++;
      }
    });

    if (visibleCount === 0) {
      showEmptyMessage(grid, effectiveDate);
    } else {
      hideEmptyMessage();
    }
  }

  function attachListeners() {
    document.addEventListener('facet:productGridUpdated', sortGrid);
    window.addEventListener('kennicott:dateChanged', sortGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachListeners);
  } else {
    attachListeners();
  }

})();
